<template>
  <div>
    <div class="full-header borderBottom">
      <div v-if="technicalWorkMessage" ref="techMessage" class="tech-message text-center body-2 py-3 px-4">
        {{ technicalWorkMessage }}
      </div>

      <div class="header navbar px-4">
        <v-icon v-if="isSmAndDown && username" class="" @click="hamburgerClick">
          mdi-menu
        </v-icon>

        <!-- logo -->
        <router-link to="/" class="d-flex td-none">
          <v-img class="logo" :src="require('@/assets/logo.png')" />

          <v-toolbar-title v-if="!isXs" class="toolbar-text accent--text">
            Сервис проведения<br>мероприятий
          </v-toolbar-title>

          <v-toolbar-title v-if="isXs" class="toolbar-text-mini accent--text d-flex align-center">
            СПМ
          </v-toolbar-title>
        </router-link>
        <v-spacer />

        <v-btn v-if="isOperatorRoles" text class="px-2" @click="isOpenedInstructions = true">
          Инструкции
        </v-btn>

        <div v-if="!isSmAndDown" class="d-flex align-center">
          <!--          <div class="my-2" v-if="username">-->
          <!--            <v-btn-->
          <!--              :class="{'mr-1': !username}"-->
          <!--              icon title="Помощь"-->
          <!--              @click.stop="$emit('openHelpDialog')"-->
          <!--            >-->
          <!--              <v-icon class="uikit-icon help-circle" />-->
          <!--            </v-btn>-->
          <!--          </div>-->

          <!--          <div class="my-2 ml-2" v-if="username">-->
          <!--            <v-btn-->
          <!--              :class="{'mr-1': !username}"-->
          <!--              icon title="Сервисы"-->
          <!--              @click.stop="$emit('openHelpDialog')"-->
          <!--            >-->
          <!--              <v-icon class="uikit-icon grid-icon" />-->
          <!--            </v-btn>-->
          <!--          </div>-->

          <div v-if="username" class="pr-3">
            <v-menu v-model="loginMenu" offset-y>
              <template #activator="{ on, attrs }">
                <div v-bind="attrs" class="d-flex d-inline align-center ml-8 pl-0 show-login-menu" :title="username" v-on="on">
                  <div class="d-flex flex-column">
                    <div class="btn-text">
                      {{ username }}
                    </div>
                  </div>
                  <v-icon class="ml-4 uikit-icon user" />
                  <!--                  <v-list-item-avatar height="35" width="35">-->
                  <!--                    <img src="https://cdn.vuetifyjs.com/images/john.jpg" :alt="username">-->
                  <!--                  </v-list-item-avatar>-->
                  <v-icon class="uikit-icon chevron-down delay-03" :class="loginMenu ? 'rotate-180': 'r0'" />
                </div>
              </template>

              <v-list>
                <v-list-item dense class="login-menu-item">
                  <v-list-item-title class="lightGrey--text body-2 v-list-username">
                    <v-icon class="uikit-icon user size-20" />
                    <span class="ml-2">{{ username }}</span>
                  </v-list-item-title>
                </v-list-item>
                <!--                <v-list-item dense class="login-menu-item">-->
                <!--                  <v-list-item-action>-->
                <!--                    <v-switch-->
                <!--                      v-model="$vuetify.theme.dark"-->
                <!--                      color="primary"-->
                <!--                    ></v-switch>-->
                <!--                  </v-list-item-action>-->
                <!--                  <v-list-item-title class="lightGrey&#45;&#45;text body-2 v-list-username">Темная</v-list-item-title>-->
                <!--                </v-list-item>-->

                <v-divider />

                <v-btn text class="login-menu-item w-full justify-start" @click="logout">
                  <v-icon class="uikit-icon log-out size-20" />
                  <span class="ml-2 btn-text">Выйти</span>
                </v-btn>
              </v-list>
            </v-menu>
          </div>
        </div>
      </div>
    </div>

    <div v-if="isSmAndDown" ref="mobileMenu" class="mobile-menu" :class="{'active': activeMenu}">
      <div class="mt-2">
        <MenuLinks v-if="username" :links="links" :is-mobile="true" />

        <!--        <div class="my-2">-->
        <!--          <v-btn class="lightGrey--text px-3" text @click.stop="$emit('openHelpDialog')">-->
        <!--            Помощь-->
        <!--          </v-btn>-->
        <!--        </div>-->

        <v-menu v-if="username" offset-y>
          <template #activator="{ on }">
            <v-btn text color="grey" class="px-3" v-on="on">
              <span class="lightGrey--text">{{ username }}</span>
              <v-icon color="lightGrey" right>
                mdi-chevron-down
              </v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-item dense @click="logout">
              <v-list-item-title class="accent--text body-1 pointer">
                Выйти
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </div>

    <BaseDialog
      :dialog="isOpenedInstructions"
      title="Инструкции"
      :is-show-action-btn="false"
      @close="isOpenedInstructions = false"
    >
      <nav class="link-list">
        <a
          v-if="isAdmin"
          class="file-link"
          @click="openInstructionsInNewTab('instructions_for_setting_up_statuses.pdf')"
        >
          <span>Инструкция по настройке статусов</span>
        </a>

        <a
          v-if="isOperatorRoles"
          class="file-link"
          @click="openInstructionsInNewTab('Инструкция по работе с СПМ.pdf')"
        >
          <span>Инструкция по работе с СПМ</span>
        </a>
      </nav>
    </BaseDialog>
  </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import MenuLinks from '@/ui/MenuLinks'
import BaseDialog from '@/ui/dialog/BaseDialog'

export default {

  components: { MenuLinks, BaseDialog },
  props: {
    links: {
      type: Array,
      default: null,
    },
    isSmAndDown: Boolean,
    isXs: Boolean,
  },

  async mounted() {
    this.onResize()
    // this.setTechnicalWorkMessage()
    // setInterval(() => this.setTechnicalWorkMessage(), 300000)

    window.addEventListener('resize', this.onResize)
  },

  destroyed() {
    window.removeEventListener('resize', this.onResize)
  },

  data: () => ({
    technicalWorkMessage: null,
    maxLoginLength: null,
    activeMenu: false,
    loginMenu: false,
    isOpenedInstructions: false,
  }),

  computed: { ...mapGetters('user', ['username', 'isAdmin', 'isOperatorRoles']) },

  methods: {
    async logout() {
      try {
        await this.$store.dispatch('user/logout')
        await this.$router.push('/spm/login')
        this.activeMenu = false
      } catch (e) {
        this.showErrorMessage(e, 'Ошибка выхода')
      }
    },

    onResize() {
      this.calcLoginLength()
      this.calcActiveMenuTop()
    },

    openInstructionsInNewTab(instructionName) {
      window.open(`/${instructionName}`, '_blank')
    },

    setTechnicalWorkMessage() {
      axios.get(`/message.json?${Math.random()}`).then((response) => {
        if (this.technicalWorkMessage !== response.data.message) {
          this.technicalWorkMessage = response.data.message
          setTimeout(() => {
            this.setTechMessageHeight()
            this.calcActiveMenuTop()
          }, 200)
        }
      })
    },

    calcLoginLength() {
      this.maxLoginLength = Math.ceil((window.innerWidth - 800) / 10)
    },

    calcActiveMenuTop() {
      const { techMessage } = this.$refs
      const { mobileMenu } = this.$refs

      if (techMessage) {
        mobileMenu && (mobileMenu.style.top = `${techMessage.offsetHeight}px`)
      } else {
        mobileMenu && (mobileMenu.style.top = 0)
      }
    },

    setTechMessageHeight() {
      const { techMessage } = this.$refs
      this.$store.dispatch('system/setTechMessageHeight', techMessage?.offsetHeight || 0)
    },

    hamburgerClick() {
      this.activeMenu = !this.activeMenu
    },
  },

  watch: {
    $route() {
      this.activeMenu = false
    },
  },
}
</script>

<style lang="scss" scoped>
.show-login-menu::before {
  background-color: transparent !important;
}

.login-menu-item {
  min-width: 150px;
  margin: 0 !important;
  border-radius: 1px !important;
}

a.td-none {
  text-decoration: none;
}

.pointer {
  cursor: pointer;
  font-weight: 400 !important;
}

.full-header {
  position: fixed;
  width: 100%;
  z-index: 6;
  &.borderBottom {
    border-bottom: 1px solid var(--v-lightGrey1-base)
  }
}
.tech-message {
  width: 100%;
  color: white;
  background-color: var(--v-error-base);
}

.header {
  display: flex;
  align-items: center;
  width: 100%;
  .lh-normal {
    line-height: 1;
  }
  .lh-more {
    line-height: 1.25;
  }
}

.logo {
  max-width: 44px;
  max-height: 44px;
  margin-left: 16px;
  margin-top: 8px;
  margin-bottom: 8px;
}

.toolbar-text {
  line-height: 1.15;
  padding-left: 10px;
  padding-top: 9px;
  font-size: 18px;
}

.toolbar-text-mini {
  line-height: 1.15;
  padding-left: 10px;
  font-size: 18px;
}

.v-list-username {
  font-weight: 400 !important;
}

.mobile-menu {
  position: fixed;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background-color: var(--v-background-base);
  padding: 65px 0 0 12px;
  z-index: 5;
  transition: left .2s ease 0s;
  &.active {
    left: 0;
  }
}

.navbar {
  background: var(--v-whiteBlack-base);
  border-bottom: 1px solid var(--v-lightGrey1-base);
}

.file-link {
  text-decoration: none;
  border-bottom: 1px dashed var(--v-primary-base);
}

.link-list {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
}
</style>
